export default {
    /* The Player is loading its initial resources, Globe is not yet initialized */
    INITIALIZING: 0,
    /* Globe is rendering, we're waiting on the user to start the screen
     * If autoplay is enabled, this state is skipped
     */
    START_SCREEN: 1,
    /* We're loading the assets necessary to start playing the scene, usually tiles.
     * The camera may be moving, and it's more interesting than the start screen.
     */
    LOADING: 2,
    /* All resources necessary to play the scene have been loaded, and we're ready to go */
    PLAYING: 3,
};
